<template>
  <div> 
    <div>
      <Navbar />
      <div class="offset">
        <div class="col-md-6">
          <Home class="fixed-home"/>
        </div>
        <div class="col-md-6">
          <Work />
          <Projects class="my-5" />
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Home from './views/Home.vue'
import Work from './views/Work.vue'
import Projects from './views/Projects.vue'
export default {
  components:{
    Navbar,
    Home,
    Work,
    Projects,
  }
}
</script>
<style scoped>
  @media only screen and (min-width: 768px) {
    .fixed-home{
      position: fixed; 
      top: 0; 
      left: 0; 
      z-index: 1020;
      right: unset;
      width: 50%;
    }
  }
</style>